import { getTVODProductPrices } from "../services/tvodService";
import { isBaseSubscription, getParentAddOn } from "../utils/mobileLiteUtils";
import {
  isStandAloneAddon,
  getAddOnByName,
  getPaymentPlanOfSubscription,
  CREDIT_CARD,
  getPaymentPlans,
  isUserSubscribedToChannel
} from "../utils/subscriptionUtils";
import { isCoupledAddOn } from "../utils/addOnsUtil";
import { redirectTo } from "../services/navigationService";
import { routes } from "../routes";
import { getAppState } from "../state";
import { i18n } from "./../services/i18nService";
import {
  getPackageTimeUnit,
  isParentSubscriptionActive,
  isSubscriptionActive,
  getPaymentPlansConfiguration,
  getGrandParentAddOnName
} from "./subscriptionExtendUtils";
import { getLocaleFromLocalCache } from "../services/localeCacheService";
import { STARZPLAYULTIMATE } from "../e2e/utils/constants";

const TVOD = "TVOD";
const SVOD = "SVOD";
const AVOD = "AVOD";
const ADMN = "admn";
const ACTIVE = "active";
const EXPIRE = "expire";
const EXPIRED = "expired";
const INIT = "init";
const STARZPLAY = "starzplay";
const STARZ = "starz";
const PURCHASE = "purchase";
const RENT = "rent";
const MONTH = "month";
export const CHAMPIONS_TROPHY = "wct2026";
export const CRICLIFE = "criclife";

let currentAssetStatus = "NULL";

export function isTVODContent(assetTypes) {
  return assetTypes && assetTypes.length > 0 && assetTypes.indexOf(TVOD) > -1;
}

export function isSVODContent(assetTypes) {
  return assetTypes && assetTypes.length > 0 && assetTypes.indexOf(SVOD) > -1;
}

export function isADMNContent(contentOwnership) {
  return contentOwnership && contentOwnership.length > 0 && contentOwnership.indexOf(ADMN) > -1;
}

export function getSectionName(isADMN, pathname) {
  return isADMN ? ADMN : "";
}
export function getApiNameSection(pathname) {
  if (pathname.startsWith("/")) {
    pathname = pathname.slice(1);
  }
  return pathname === "admn" ? "admnhome" : pathname;
}
export const isADMNRoute = pathname => {
  if (!pathname) return false;
  return pathname?.includes("admn");
};
export function isAVODContent(assetTypes) {
  return assetTypes && assetTypes.length > 0 && assetTypes.indexOf(AVOD) > -1;
}

export const isTVODPriority = type => {
  return type === TVOD;
};

export const isSVODPriority = type => {
  return type === SVOD;
};

export const isAVODPriority = type => {
  return type === AVOD;
};

export const isTVOD = videoData => {
  return (
    (videoData.assetTypes &&
      videoData.assetTypes.length > 0 &&
      isTVODContent(videoData.assetTypes) &&
      isTVODPriority(videoData.assetTypesPriority)) ||
    false
  );
};

export const isAVOD = videoData => {
  return (
    (videoData.assetTypes &&
      videoData.assetTypes.length > 0 &&
      isAVODContent(videoData.assetTypes) &&
      isAVODPriority(videoData.assetTypesPriority)) ||
    false
  );
};

export const isSVOD = videoData => {
  return (
    (videoData.assetTypes &&
      videoData.assetTypes.length > 0 &&
      isSVODContent(videoData.assetTypes) &&
      isSVODPriority(videoData.assetTypesPriority)) ||
    false
  );
};

export function getTVODInitStatus() {
  return currentAssetStatus.toLowerCase() === INIT;
}

export function expiredContent(status) {
  return status.toLowerCase() === EXPIRE || status.toLowerCase() === EXPIRED;
}

export function displayCWPrices(data) {
  const { id, seriesId, title, images, products } = data;

  let rentCtaData = null;
  let rentPrice;
  let isOldNewRent = false;
  let purchaseCtaData = null;
  let purchasePrice;
  let isOldNewPurchase = false;

  if (products.rent) {
    rentCtaData = {
      contentId: seriesId ? seriesId : id,
      contentTitle: title,
      contentImage: images.posterLandscape,
      newPriceId: products.rent.priceProduct,
      newPrice: products.rent.new,
      oldPrice: products.rent.old,
      newPriceCurrency: products.rent.currency
    };
    if (products.rent.old && products.rent.new) {
      isOldNewRent = true;
      rentPrice =
        i18n.getDirection() === "ltr"
          ? `<span style="text-decoration: line-through; font-size: 1.3rem;">${products.rent.currency} ${products.rent.old}</span> ${products.rent.currency} ${products.rent.new}`
          : `${products.rent.currency} ${products.rent.new} <span style="text-decoration: line-through; font-size: 1.3rem;">${products.rent.currency} ${products.rent.old}</span>`;
    } else if (!products.rent.old && products.rent.new) {
      rentPrice = `${products.rent.currency} ${products.rent.new}`;
    } else if (products.rent.old && !products.rent.new) {
      rentPrice = `${products.rent.currency} ${products.rent.old}`;
    } else {
      rentPrice = "";
    }
  }
  if (products.purchase) {
    purchaseCtaData = {
      contentId: seriesId ? seriesId : id,
      contentTitle: title,
      contentImage: images.posterLandscape,
      newPriceId: products.purchase.priceProduct,
      newPrice: products.purchase.new,
      oldPrice: products.purchase.old,
      newPriceCurrency: products.purchase.currency
    };
    if (products.purchase.old && products.purchase.new) {
      isOldNewPurchase = true;
      purchasePrice =
        i18n.getDirection() === "ltr"
          ? `<span style="text-decoration: line-through; font-size: 1.3rem;">${products.purchase.currency} ${products.purchase.old}</span> ${products.purchase.currency} ${products.purchase.new}`
          : `${products.purchase.currency} ${products.purchase.new} <span style="text-decoration: line-through; font-size: 1.3rem;">${products.purchase.currency} ${products.purchase.old}</span>`;
    } else if (!products.purchase.old && products.purchase.new) {
      purchasePrice = `${products.purchase.currency} ${products.purchase.new}`;
    } else if (products.purchase.old && !products.purchase.new) {
      purchasePrice = `${products.purchase.currency} ${products.purchase.old}`;
    } else {
      purchasePrice = "";
    }
  }

  return { rentCtaData, rentPrice, isOldNewRent, purchaseCtaData, purchasePrice, isOldNewPurchase };
}

export function displayEpisodePrices(data) {
  const { rentLabel, oldRentLabel, purchaseLabel, oldPurchaseLabel } = data;
  let rentPrice;
  let purchasePrice;

  if (rentLabel && oldRentLabel) {
    rentPrice =
      i18n.getDirection() === "ltr"
        ? `<span style="text-decoration: line-through; font-size: 1.3rem;">${oldRentLabel}</span> ${rentLabel}`
        : `${rentLabel} <span style="text-decoration: line-through; font-size: 1.3rem;">${oldRentLabel}</span>`;
  } else if (rentLabel && !oldRentLabel) {
    rentPrice = rentLabel;
  } else {
    rentPrice = oldRentLabel;
  }

  if (purchaseLabel && oldPurchaseLabel) {
    purchasePrice =
      i18n.getDirection() === "ltr"
        ? `<span style="text-decoration: line-through; font-size: 1.3rem;">${oldPurchaseLabel}</span> ${purchaseLabel}`
        : `${purchaseLabel} <span style="text-decoration: line-through; font-size: 1.3rem;">${oldPurchaseLabel}</span>`;
  } else if (purchaseLabel && !oldPurchaseLabel) {
    purchasePrice = purchaseLabel;
  } else {
    purchasePrice = oldPurchaseLabel;
  }

  return { rentPrice, purchasePrice };
}

export const getModifiedPrices = (listOfIds, data) => {
  const [purchaseId, rentId, oldPurchaseId, oldRentId] = listOfIds;

  let modifiedData;
  if (data && data.length !== 0) {
    modifiedData = data.filter(price => {
      if (
        price.priceProduct === purchaseId ||
        price.priceProduct === rentId ||
        price.priceProduct === oldPurchaseId ||
        price.priceProduct === oldRentId
      ) {
        price.isPurchaseId = price.priceProduct === purchaseId;
        price.isRentId = price.priceProduct === rentId;
        price.isOldPurchaseId = price.priceProduct === oldPurchaseId;
        price.isOldRentId = price.priceProduct === oldRentId;
        return true;
      }
      return false;
    });
  }
  return modifiedData;
};

export const getAssetPrices = async (assetData, country, isTVOD, tvodStatus) => {
  const purchaseId = assetData.purchaseProductId && assetData.purchaseProductId;
  const rentId = assetData.rentProductId && assetData.rentProductId;
  const oldPurchaseId = assetData.oldPurchaseProductId && assetData.oldPurchaseProductId;
  const oldRentId = assetData.oldRentProductId && assetData.oldRentProductId;

  let priceData;
  if (isTVOD) {
    const listOfIds = [purchaseId, rentId, oldPurchaseId, oldRentId];
    const status = tvodStatus;
    if (!status || (status && status.length === 0)) {
      const prices = await getTVODProductPrices(listOfIds, country);
      priceData = getModifiedPrices(listOfIds, prices);
    } else if (status && status.length > 0) {
      currentAssetStatus = status[0].status;
      const isExpired = expiredContent(status[0].status);
      const prices = isExpired && (await getTVODProductPrices(listOfIds, country));
      priceData = getModifiedPrices(listOfIds, prices);
    } else {
      priceData = [];
    }
  }
  return priceData;
};

function expireTime(item) {
  if (
    item.license &&
    item.license.type &&
    item.license.type.toLowerCase() === RENT &&
    ((item.license.state && item.license.state.toLowerCase() === ACTIVE) ||
      (item.license.state && item.license.state.toLowerCase() === INIT))
  ) {
    const today = new Date();
    const tsExpire = item.license.tsExpire * 1000;
    let exTime = tsExpire - today;
    const hours = Math.floor(exTime / (1000 * 3600));
    const minutes = Math.floor((exTime % (1000 * 3600)) / (1000 * 60));
    const days = Math.floor(hours / 24);
    const remHours = Math.floor(hours % 24);
    if (exTime > 0) {
      if (days > 2) {
        item.remTime = `${i18n.get("global.tagLabels.days", days)} ${i18n.get("global.tagLabels.hours", remHours)}`;
      } else if (hours > 0) {
        item.remTime = `${i18n.get("global.tagLabels.hours", hours)} ${i18n.get("global.tagLabels.mints", minutes)}`;
      } else {
        item.remTime = `${i18n.get("global.tagLabels.mints", minutes)}`;
      }
    } else {
      item.remTime = "";
    }
  }
}
export function tvodTimeExpire(modules) {
  return (modules = modules.filter(module => module?.titles?.some(item => expireTime(item))));
}
export function tvodSearchTimeExpire(titles) {
  return (titles = titles?.some(item => expireTime(item)));
}

export function pramsYouborra(isTVOD, license) {
  let contentType;
  if (isTVOD) {
    if (
      license &&
      license?.type?.toLowerCase() === PURCHASE &&
      (license?.state?.toLowerCase() === INIT || license?.state?.toLowerCase() === ACTIVE)
    ) {
      contentType = "BUY";
    }
    if (
      license &&
      license.type?.toLowerCase() === RENT &&
      (license?.state?.toLowerCase() === INIT || license?.state?.toLowerCase() === ACTIVE)
    ) {
      contentType = "RENT";
    }
  }
  return contentType;
}

export function getSuperParentAddOnName(addons, addOnName) {
  if (isStandAloneAddon(addOnName)) {
    return addOnName;
  } else {
    const parentAddOn = getParentAddOn(addOnName);
    return parentAddOn ? getSuperParentAddOnName(addons, parentAddOn.name) : null;
  }
}

export function getSuperParentAddOnNameForSVOD(addons, addOnName) {
  if (isBaseSubscription(addOnName)) {
    return STARZPLAY;
  } else {
    return getSuperParentAddOnName(addons, addOnName);
  }
}

export function redirectToBuyBrandsPage(data) {
  redirectTo.call(this, routes.buyBrands, { data: data });
  return;
}

export function findFromBrands(name, providedArray) {
  return providedArray?.find(channel => {
    if (channel.name === name) return true;
    if (channel.brands) return findFromBrands(name, channel.brands);
    return false;
  });
}

export function getBrandsName(addons, brandName) {
  const parentAddOnName = getParentNameOfBrand(brandName);
  const parentSubscriptionName = getSuperParentAddOnNameForSVOD(addons, parentAddOnName);
  const parentSubscription = getAddOnByName(parentSubscriptionName);
  return parentSubscription;
}
export function getIsTimePassActive() {
  let isOneTimePassActive = false;
  getAppState().addons.forEach(addon => {
    const isHaveParent = getAddOnByName(addon.name)?.configuration?.includedIn;
    if (isSubscriptionActive(getAppState().addons, addon.name) && !isHaveParent) {
      isOneTimePassActive = true;
    } else if (isSubscriptionActive(getAppState().addons, addon.name) && isHaveParent) {
      isOneTimePassActive = false;
    }
  });
  return isOneTimePassActive;
}

export function getBuyBrandsInfoObj(addons, brandName, childAddon = null) {
  let currentAddOn = getAddOnByName(brandName);
  const parentAddOnName = getParentNameOfBrand(brandName);
  let parentSubscriptionName, buttonDisplayName, action;

  parentSubscriptionName = getSuperParentAddOnNameForSVOD(addons, parentAddOnName);
  const isOneTimePassActive = getIsTimePassActive();
  buttonDisplayName = getAppState().isSvodUser ? (!isOneTimePassActive ? `activate` : `subscribe`) : `subscribe`;
  action = `activate`;

  let isToShowMultipleSubscriptions = false;

  getAppState().subscriptions.forEach(addon => {
    if (
      parentSubscriptionName === STARZPLAY &&
      addon.name === STARZPLAYULTIMATE &&
      addon.configuration.subscriptionIncludes.includes(parentSubscriptionName)
    ) {
      isToShowMultipleSubscriptions = true;
    }
  });

  const parentSubscription = getAddOnByName(parentSubscriptionName);
  if (isBaseSubscription(parentSubscriptionName)) {
    getAppState().subscriptions.forEach(subscription => {
      if (subscription.brands.length > 0) {
        subscription.brands.forEach(brand => {
          if (brand.name === brandName) {
            currentAddOn = brand;
          }
        });
      }
    });
  }
  let paymentPlans = getPaymentPlans(parentSubscription);
  const logoImage = currentAddOn
    ? `${currentAddOn?.configuration.logoDefaultPNG}`
    : `${parentSubscription?.configuration.logoDefaultPNG}`;
  let logoCoupledImage = null;

  let subscriptionDisplayName = parentSubscription && parentSubscription.displayName;

  let paymentPlan, grossAmount, price, packageTimeUnit, planName, planDisplayName, paymentPlanName;

  const monthlyPlan = paymentPlans.find(plan => plan.planType?.toLowerCase() === "month");
  if (monthlyPlan) {
    paymentPlan = monthlyPlan;
    grossAmount = monthlyPlan?.grossAmount;
    price = `${grossAmount} ${monthlyPlan?.currency}`;
    packageTimeUnit = `/${getPackageTimeUnit(monthlyPlan?.packageTimeUnit, monthlyPlan?.packageDuration)}`;
    planName = monthlyPlan?.planName;
  } else if (paymentPlans.length === 1) {
    // if single payment plan  case

    paymentPlan = paymentPlans[0];
    grossAmount = paymentPlan?.grossAmount;
    price = `${paymentPlan?.currency} ${grossAmount}`;
    packageTimeUnit = `/${getPackageTimeUnit(paymentPlan?.packageTimeUnit, paymentPlan?.packageDuration)}`;
    planName = paymentPlan?.planName;
  } else {
    // multiple Payment plan case
    paymentPlan = getPaymentPlanOfSubscription(parentSubscription);

    if (action !== "activate") {
      // t20wc24  consider annual plan if multiple plan avialable instead of monthly.
      grossAmount = paymentPlan?.grossAmount;
      price = `${paymentPlan?.currency} ${grossAmount}`;
      packageTimeUnit = `/${getPackageTimeUnit(paymentPlan?.packageTimeUnit, paymentPlan?.packageDuration)}`;
      planName = paymentPlan?.planName;
    } else {
      grossAmount = paymentPlan?.recurring
        ? getRoundToTwoNumbers(paymentPlan?.grossAmount / paymentPlan?.packageDuration)
        : paymentPlan?.grossAmount;

      price = `${paymentPlan?.currency} ${grossAmount}`;
      const unitTime =
        paymentPlan?.packageTimeUnit === MONTH ? i18n.get(`pages.brands.month`) : paymentPlan?.packageTimeUnit;
      packageTimeUnit = paymentPlan?.recurring ? `/${unitTime}` : "";
      planName = paymentPlan?.planName;
    }
  }

  if (buttonDisplayName !== "activate" && buttonDisplayName !== "subscribe") {
    let paymentPlansConfig = getPaymentPlansConfiguration(parentSubscription);
    const locale = getLocaleFromLocalCache();
    const planNamePlacehoder = planName.replace("months", "month");
    paymentPlanName = paymentPlansConfig[`${planNamePlacehoder}s_display_name_${locale}`];
    planDisplayName = `${i18n.get(`pages.brands.${buttonDisplayName}`)}${paymentPlanName}`.toUpperCase();
  }

  let buyBrandsPackageTimeUnit = packageTimeUnit;
  let promotions =
    paymentPlan && paymentPlan?.promotionDurationInDays
      ? i18n.get(`pages.brands.promotions`, paymentPlan?.promotionDurationInDays, price, packageTimeUnit)
      : action !== "switch" && paymentPlans.length > 1
      ? monthlyPlan
        ? i18n.get(`pages.brands.getItFor`, price, packageTimeUnit)
        : i18n.get(`pages.brands.multiPlanAmount`, price, packageTimeUnit)
      : i18n.get(`pages.brands.amount`, price, packageTimeUnit);

  const translation =
    buttonDisplayName === "activate"
      ? i18n.get(
          `pages.brands.inActiveSubscriptions.${parentSubscriptionName}`,
          currentAddOn?.displayName.toUpperCase(),
          parentSubscription?.displayName.toUpperCase()
        )
      : i18n.get(
          `pages.brands.inActiveSubscriptions.switchPlan.${parentSubscriptionName}`,
          parentSubscription?.displayName.toUpperCase(),
          currentAddOn?.displayName.toUpperCase()
        );
  let concatenatedString = translation.concat(promotions);

  const coupledObj = isCoupledAddOn(brandName);
  let isBilledOnce = false;

  if (coupledObj) {
    // coupled Flow
    const isChildActive = isUserSubscribedToChannel(addons, coupledObj.child);
    const isParentActive = isUserSubscribedToChannel(addons, coupledObj.parent);
    let childCoupleAddon = getAddOnByName(coupledObj.child);
    let parentCoupleAddon = getAddOnByName(coupledObj.parent);

    const isBothInActive = !isParentActive && !isChildActive;
    if (isBothInActive) {
      // use Parent Price
      paymentPlan = getPaymentPlanOfSubscription(parentCoupleAddon);
      let grossAmountParent = paymentPlan?.recurring
        ? getRoundToTwoNumbers(paymentPlan?.grossAmount / paymentPlan?.packageDuration)
        : paymentPlan?.grossAmount;
      price = `${paymentPlan?.currency} ${grossAmountParent}`;
      const unitTime =
        paymentPlan?.packageTimeUnit === MONTH ? i18n.get(`pages.brands.month`) : paymentPlan?.packageTimeUnit;
      let packageTimeUnit = paymentPlan?.recurring ? `/${unitTime}` : "";
      buyBrandsPackageTimeUnit = packageTimeUnit;
      subscriptionDisplayName = `${parentCoupleAddon.displayName} & ${childCoupleAddon.displayName}`;
      const amount = i18n.get(`pages.brands.amount`, price, packageTimeUnit);
      const coupledKeyName = `${parentCoupleAddon.name}&${childCoupleAddon.name}`;
      concatenatedString = i18n.get(`pages.brands.inActiveSubscriptions.${coupledKeyName}`);
      concatenatedString = concatenatedString.concat(amount);
      parentSubscriptionName = parentCoupleAddon.name;
      logoCoupledImage = parentCoupleAddon?.configuration.logoCoupledPNG;
      paymentPlans = getPaymentPlans(parentCoupleAddon);
    } else if (isParentActive && !isChildActive) {
      // use Child Price
      const paymentPlan = getPaymentPlanOfSubscription(childCoupleAddon);
      const mop = childCoupleAddon.paymentMethods.find(paymentMethod => paymentMethod.paymentType === CREDIT_CARD);
      let grossAmountChild =
        mop && mop.configuration && mop.configuration.priceWithParent
          ? mop.configuration.priceWithParent
          : paymentPlan?.recurring
          ? getRoundToTwoNumbers(paymentPlan?.grossAmount / paymentPlan?.packageDuration)
          : paymentPlan?.grossAmount;

      price = `${paymentPlan?.currency} ${grossAmountChild}`;
      packageTimeUnit = i18n.get(`pages.brands.only`);
      buyBrandsPackageTimeUnit = "";
      const amount = i18n.get(`pages.brands.amount`, price, packageTimeUnit);
      concatenatedString = i18n.get(`pages.brands.inActiveSubscriptions.${childCoupleAddon.name}`);
      concatenatedString = concatenatedString.concat(amount);
      parentSubscriptionName = childCoupleAddon.name;
      isBilledOnce = true;
      paymentPlans = getPaymentPlans(childCoupleAddon);
    }
  }

  return {
    logoImage,
    concatenatedString,
    price,
    packageTimeUnit,
    subscriptionName: parentSubscriptionName,
    subscriptionDisplayName,
    isBilledOnce,
    logoCoupledImage,
    buyBrandsPackageTimeUnit,
    paymentPlans,
    buttonDisplayName,
    planDisplayName,
    paymentPlanName,
    paymentPlan,
    action,
    isMonthlyPlan: monthlyPlan ? true : false,
    isToShowMultipleSubscriptions: isToShowMultipleSubscriptions || false,
    isOneTimePassActive
  };
}

export function getBuyBrandsInfoObjChampionsTrophy(addons, brandName) {
  let currentAddOn = getAddOnByName(brandName);
  const parentAddOnName = getParentNameOfBrand(brandName);
  let parentSubscriptionName = getSuperParentAddOnNameForSVOD(addons, parentAddOnName);
  const parentSubscription = getAddOnByName(parentSubscriptionName);

  let buttonDisplayName = "activate",
    action,
    descHeaderTranslation,
    pricingOnBannerTranslation,
    isShowUpgradeDisclaimer = false;
  let pricingAction = "standalone";
  let isAnyEligibleSubscriptionActive = false;
  let isRecurringPlan = false;

  // START - Logic for Showing Button Text
  const isParentActive = isUserSubscribedToChannel(addons, parentSubscription?.name);
  let subscriptionDisplayName = parentSubscription && parentSubscription.displayName;
  let isOneTimePassPriorityFlag = false;

  if (isParentActive) {
    subscriptionDisplayName = currentAddOn?.displayName;
    isOneTimePassPriorityFlag = true;

    descHeaderTranslation = i18n.get(
      `pages.layout.activationBanner.standalone.header`,
      currentAddOn?.displayName.toUpperCase()
    );
  } else {
    // check eligible subs

    const listOfEligibleSubscriptionNames = currentAddOn?.configuration?.eligibleSubs?.split(",") || [];
    listOfEligibleSubscriptionNames.every(subName => {
      if (isUserSubscribedToChannel(addons, subName)) {
        isAnyEligibleSubscriptionActive = true;
        return false;
      }
      return true;
    });
    if (isAnyEligibleSubscriptionActive) {
      // if Any Eligible Subscription is Active, then treat whole flow as standalone
      subscriptionDisplayName = currentAddOn?.displayName;
      isOneTimePassPriorityFlag = true;
      descHeaderTranslation = i18n.get(
        `pages.layout.activationBanner.standalone.header`,
        currentAddOn?.displayName.toUpperCase()
      );
    } else {
      // Now if parent is not active, also not any subscriptions active, then definitely it is not standalone. Now we have to check if upgrade Text or Active text.
      // check if any child of the parent is active or not.
      let isAnyChildOfParentActive = getIsAnyChildOfParentActive(parentSubscription, addons);
      pricingAction = "upgrade";
      if (isAnyChildOfParentActive) {
        subscriptionDisplayName = parentSubscription && parentSubscription.displayName;
        buttonDisplayName = "upgrade";
        isShowUpgradeDisclaimer = true;
        descHeaderTranslation = i18n.get(
          `pages.layout.activationBanner.upgrade.header`,
          parentSubscription?.displayName.toUpperCase()
        );
      } else {
        subscriptionDisplayName = parentSubscription && parentSubscription.displayName;
        descHeaderTranslation = i18n.get(
          `pages.layout.activationBanner.parent+addon.header`,
          currentAddOn?.displayName.toUpperCase(),
          parentSubscription?.displayName.toUpperCase()
        );
      }
    }
  }

  // END - Logic for Showing Button Text

  if (isBaseSubscription(parentSubscriptionName)) {
    getAppState().subscriptions.forEach(subscription => {
      if (subscription.brands.length > 0) {
        subscription.brands.forEach(brand => {
          if (brand.name === brandName) {
            currentAddOn = brand;
            subscriptionDisplayName = parentSubscription && parentSubscription.displayName;
            buttonDisplayName = "activate";
            descHeaderTranslation = i18n.get(
              `pages.layout.activationBanner.starzplay.header`,
              parentSubscription?.displayName.toUpperCase()
            );
            pricingAction = "upgrade";
          }
        });
      }
    });
  }

  // START - Pricing on Banner

  let pricingAddOn = null;
  if (pricingAction === "standalone") {
    pricingAddOn = currentAddOn;
  } else if (pricingAction === "upgrade") {
    pricingAddOn = parentSubscription;
  }

  let paymentPlans = getPaymentPlans(pricingAddOn);

  let paymentPlan, grossAmount, price, packageTimeUnit, planName, planDisplayName, paymentPlanName;

  // the pricing shall default to Monthly plan, If monthly plan is not available, we shall rely on the current logic

  const monthlyPlan = paymentPlans.find(plan => plan.planType?.toLowerCase() === "month");
  if (monthlyPlan) {
    paymentPlan = monthlyPlan;
    grossAmount = monthlyPlan?.grossAmount;
    price = `${grossAmount} ${monthlyPlan?.currency}`;
    packageTimeUnit = `/${getPackageTimeUnit(monthlyPlan?.packageTimeUnit, monthlyPlan?.packageDuration)}`;
    planName = monthlyPlan?.planName;
    isRecurringPlan = monthlyPlan?.recurring;
  } else {
    // current Logic
    if (paymentPlans.length === 1) {
      // if single payment plan  case

      paymentPlan = paymentPlans[0];
      grossAmount = paymentPlan?.grossAmount;
      price = `${grossAmount} ${paymentPlan?.currency}`;
      packageTimeUnit = `/${getPackageTimeUnit(paymentPlan?.packageTimeUnit, paymentPlan?.packageDuration)}`;
      planName = paymentPlan?.planName;
      isRecurringPlan = paymentPlan?.recurring;
    } else {
      // multiple Payment plan case
      paymentPlan = getPaymentPlanOfSubscription(parentSubscription);

      grossAmount = paymentPlan?.recurring
        ? getRoundToTwoNumbers(paymentPlan?.grossAmount / paymentPlan?.packageDuration)
        : paymentPlan?.grossAmount;

      price = `${grossAmount} ${paymentPlan?.currency}`;
      const unitTime =
        paymentPlan?.packageTimeUnit === MONTH ? i18n.get(`pages.brands.month`) : paymentPlan?.packageTimeUnit;
      packageTimeUnit = paymentPlan?.recurring ? `/${unitTime}` : "";
      planName = paymentPlan?.planName;
      isRecurringPlan = paymentPlan?.recurring;
    }
  }

  // ICC Champions Trophy Work
  const CTInfoObj = getSeasonPassData(parentSubscription, CHAMPIONS_TROPHY);
  let CTAddOnData = { ...getAddOnByName(CHAMPIONS_TROPHY) };
  if (
    ((isAdditionalAddOn(currentAddOn) && isParentActive) || isAnyEligibleSubscriptionActive) &&
    !isUserSubscribedToChannel(addons, currentAddOn?.name)
  ) {
    CTAddOnData.isCTStandalone = true;
  } else if (CTInfoObj?.adMonthData && CTInfoObj?.adYearData) {
    CTAddOnData.CTPrices = getChampionTrophyPrices(CTInfoObj?.adMonthData, CTInfoObj?.adYearData);
  } else if (CTInfoObj?.adMonthData) {
    CTAddOnData.CTPrices = getChampionTrophyPrices(CTInfoObj?.adMonthData, null);
  } else if (CTInfoObj?.adYearData) {
    CTAddOnData.CTPrices = getChampionTrophyPrices(null, CTInfoObj?.adYearData);
  } else {
    CTAddOnData = null;
  }

  let buyBrandsPackageTimeUnit = packageTimeUnit;
  const priceToShowText = `${price}${packageTimeUnit}`;

  // season pass is attached with Subscription and subscription is not active
  if (
    (currentAddOn?.name === CRICLIFE || isAdditionalAddOn(currentAddOn)) &&
    !isParentActive &&
    !isAnyEligibleSubscriptionActive
  ) {
    pricingOnBannerTranslation = `${i18n.get(`pages.layout.activationBanner.parent+addon.subHeader`, priceToShowText)}`;

    // If the season pass is free with monthly, we shall not show the season pass pricing
    pricingOnBannerTranslation += CTAddOnData?.CTPrices?.monthlyPrice
      ? `${i18n.get(`pages.layout.activationBanner.parent+addon.additionalIn`, CTAddOnData?.CTPrices?.monthlyPrice)}`
      : "";
  } else if (
    // season pass is attached with Subscription and subscription is active, but season pass is not active
    ((isAdditionalAddOn(currentAddOn) && isParentActive) || isAnyEligibleSubscriptionActive) &&
    !isUserSubscribedToChannel(addons, currentAddOn?.name)
  ) {
    const oneTimePaymentTranslation = isRecurringPlan ? "" : i18n.get("pages.buyBrands.oneTimePayment", "");
    pricingOnBannerTranslation = i18n.get(
      `pages.layout.activationBanner.${pricingAction}.subHeader`,
      `${price}${oneTimePaymentTranslation}`
    );
  } else {
    pricingOnBannerTranslation = i18n.get(`pages.layout.activationBanner.${pricingAction}.subHeader`, priceToShowText);
  }

  // END - Pricing on Banner

  // START - Logo Img

  const logoImage = currentAddOn
    ? `${currentAddOn?.configuration.logoDefaultPNG}`
    : `${parentSubscription?.configuration.logoDefaultPNG}`;

  // END - Logo Img

  return {
    logoImage,
    price,
    packageTimeUnit,
    subscriptionName: parentSubscriptionName,
    subscriptionDisplayName,
    buyBrandsPackageTimeUnit,
    paymentPlans,
    buttonDisplayName,
    planDisplayName,
    paymentPlanName,
    paymentPlan,
    action,
    descHeaderTranslation,
    pricingOnBannerTranslation,
    planName,
    CTAddOnData,
    isRecurringPlan,
    isShowUpgradeDisclaimer,
    isOneTimePassPriorityFlag
  };
}

function getChampionTrophyPrices(monthData, yearData) {
  let monthlyPrice = 0,
    annualPrice = 0;
  if (monthData && !monthData.isFree) {
    const addonData = getAddOnByName(monthData?.name);
    const price = addonData.paymentMethods[0].paymentPlans[0].netAmount;
    const currency = addonData.paymentMethods[0].paymentPlans[0].currency;
    monthlyPrice = `${price} ${currency}`;
  }
  if (yearData && !yearData.isFree) {
    const addonData = getAddOnByName(yearData?.name);
    const price = addonData.paymentMethods[0].paymentPlans[0].netAmount;
    const currency = addonData.paymentMethods[0].paymentPlans[0].currency;
    annualPrice = `${price} ${currency}`;
  }
  return { monthlyPrice, annualPrice };
}

export function getSeasonPassData(parentSubscription, addonName) {
  const parentSubConfig = parentSubscription?.paymentMethods[0].configuration;
  const adMonthData =
    parentSubConfig?.MONTH_configs?.additionalAddons && parentSubConfig?.MONTH_configs?.additionalAddons.length !== 0
      ? parentSubConfig.MONTH_configs?.additionalAddons.find(item => item.name === addonName)
      : null;
  const adYearData =
    parentSubConfig?.YEAR_configs?.additionalAddons && parentSubConfig?.YEAR_configs?.additionalAddons.length !== 0
      ? parentSubConfig.YEAR_configs?.additionalAddons.find(item => item.name === addonName)
      : null;
  return { adMonthData, adYearData };
}

// This function is used to check if this addOn is additional addon of some subscription, mean it is not the direct child. Mean, if user will buy the subscription, user can select or deselect to buy this additional addon
function isAdditionalAddOn(addOnObj) {
  if (
    addOnObj &&
    addOnObj.configuration &&
    addOnObj.configuration["additionalIn"] &&
    addOnObj.configuration["additionalIn"].subscriptions &&
    addOnObj.configuration["additionalIn"].subscriptions.length > 0
  ) {
    return true;
  }
  return false;
}

export function getIsAnyChildOfParentActive(parentSubscription, addons) {
  let isAnyChildOfParentActive = false;
  const listOfChildSubscriptionNames = parentSubscription?.configuration?.subscriptionIncludes?.split(",") || [];
  listOfChildSubscriptionNames.every(subName => {
    if (isUserSubscribedToChannel(addons, subName)) {
      isAnyChildOfParentActive = true;
      return false;
    }
    return true;
  });
  return isAnyChildOfParentActive;
}

export function getBuyBrandsActivateDisplayName(addons, brandName) {
  const parentAddOnName = getParentNameOfBrand(brandName);
  let parentSubscriptionName = getSuperParentAddOnNameForSVOD(addons, parentAddOnName);
  const parentSubscription = getAddOnByName(parentSubscriptionName);

  let subscriptionDisplayName = parentSubscription && parentSubscription.displayName;

  const coupledObj = isCoupledAddOn(brandName);
  if (coupledObj) {
    // coupled Flow
    let childCoupleAddon = getAddOnByName(coupledObj.child);
    let parentCoupleAddon = getAddOnByName(coupledObj.parent);
    subscriptionDisplayName = `${parentCoupleAddon.displayName} & ${childCoupleAddon.displayName}`;
  }

  return subscriptionDisplayName;
}

export function getRoundToTwoNumbers(num) {
  return Math.ceil(num * 100) / 100;
}
export function getParentNameOfBrand(addonContent) {
  let addOnsList = [];
  if (isBaseSubscription(addonContent)) {
    addOnsList =
      (getAppState().subscriptions && getAppState().subscriptions?.filter(data => data?.name === STARZPLAY)) || [];
    // return addOnsList[0].name;
    if (addOnsList?.length > 0) {
      return addOnsList[0].name;
    } else {
      return "";
    }
  }
  addOnsList =
    (getAppState().subscriptions && getAppState().subscriptions?.filter(data => data?.name === addonContent)) || [];
  // if getting empty list then may be it will be a brand and not an add-on
  // check for brands now
  if (addOnsList.length === 0) {
    getAppState().subscriptions &&
      getAppState().subscriptions.forEach(subscription => {
        if (subscription.brands.length > 0) {
          subscription.brands.forEach(brand => {
            if (brand.name === addonContent) {
              addOnsList = [subscription];
            }
          });
        }
      });
  }
  return addOnsList.length > 0 ? addOnsList[0].name : null;
}

export function isBaseContent(name) {
  return name && (name === STARZ || name === STARZPLAY);
}

export function isBaseContentBrand(name) {
  const base = getAppState().subscriptions?.filter(data => data?.name === STARZPLAY);
  const baseBrands = base && [...base[0]?.brands];
  return baseBrands?.find(addon => addon.name === name);
}

export function isContentActive(addons, addonContent, titleSubscriptionsArr = []) {
  if (isBaseContent(addonContent)) {
    return getAppState().userAccountStatus?.toLowerCase() === "active" ? true : false;
  } else {
    const addOnName = getParentNameOfBrand(addonContent);
    const subscriptionName = getSuperParentAddOnNameForSVOD(addons, addOnName);
    const isActiveContent = isUserSubscribedToChannel(addons, subscriptionName, titleSubscriptionsArr);
    return isActiveContent ? true : false;
  }
}

export function isTvodFlowForPlayback(tvodStatus) {
  let isTVODFlow = false;
  if (tvodStatus && tvodStatus.length > 0) {
    isTVODFlow =
      tvodStatus[0].status.toLowerCase() === "init" || tvodStatus[0].status.toLowerCase() === "active" ? true : false;
  }
  return isTVODFlow;
}

export function isTvodExpired(tvodStatus) {
  let isExpired = false;
  if (tvodStatus && tvodStatus.length > 0) {
    isExpired = expiredContent(tvodStatus[0].status);
  }
  return isExpired;
}

export function setCurrentStatusForPlayer(tvodStatus) {
  if (tvodStatus && tvodStatus.length > 0) {
    currentAssetStatus = tvodStatus[0].status;
  }
}

export function setCurrentStatusForPlayerObj(obj) {
  currentAssetStatus = (obj && obj.state) || "";
}

export function getLast3MonthsData(data) {
  const today = new Date();
  const threeMonthsAgo = new Date();
  threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
  const filteredData =
    data &&
    data.filter(item => {
      const dateFormate = new Date(item.purchasedDate.replace(/ /, "T"));
      const parseDate = Date.parse(dateFormate);
      const purchaseDate = new Date(parseDate);
      return purchaseDate >= threeMonthsAgo && purchaseDate <= today;
    });
  return filteredData || [];
}
